import { omit } from 'lodash-es'
import { FC } from 'react'
import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroidery } from '../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import { LogoFormContainer } from '../LogoFormContainer'

import * as LogoPreviewItem from './LogoPreviewItem'

export const AddNewLogoButton: FC = () => {
  const { logoDisplayPrices, displayLogoForm } = LogoFormContainer.useContainer()
  const { setEmbroiderySelections } = useEmbroidery()
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()

  const handleAddNewLogoClick = () => {
    setEmbroiderySelections(prev => omit(prev, ['LOGO_SETUP', 'LOGO_COLOR', 'LOGO_BLACK_WHITE']))
    displayLogoForm('LOGO_SETUP')
  }

  return (
    <Container>
      <LogoPreviewItem.Label>
        <LogoPreviewItem.Input type='button' name='logoFileId' onClick={handleAddNewLogoClick} />
        <AddNewLogoButtonWrapper>
          <AddNewLogoCta>{fixtures.addNewLogo}</AddNewLogoCta>
          <SetupPrice>+{logoDisplayPrices.setup}</SetupPrice>
        </AddNewLogoButtonWrapper>
      </LogoPreviewItem.Label>
    </Container>
  )
}

const AddNewLogoCta = styled(TypeStyle.HeadlineExtraSmall)`
  font-size: 16px;
  max-width: 109px;
  text-align: center;
`

const Container = styled(LogoPreviewItem.Container)`
  border: 2px dashed ${({ theme }) => theme.color.deprecated.stone};
  background-color: ${({ theme }) => theme.color.deprecated.white.primary};
`
const SetupPrice = styled(TypeStyle.HeadlineExtraExtraSmall)`
  color: ${o => o.theme.color.deprecated.obsidianLight};
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.6px;
  font-weight: ${o => o.theme.typography.font.weight[700]};
`
const AddNewLogoButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`
